"use client";

import { useContext, forwardRef } from "react";
import styled from "styled-components";
import { OverflowContext } from "../utils/context";
import { mergeRefs } from "@churchofjesuschrist/eden-utilities";
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollContainer = styled.div.withConfig({
  componentId: "sc-cxooho-0"
})(["position:relative;overflow:auto;z-index:1;"]);

/**
 * Use nested in the Fade component to enable scrolling with the automatic application of a Fade in any direction (top/bottom/left/right) that the content is overflowing.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.children] The content to scroll.
 * @param {React.ElementType} [props.renderAs] The HTML tag string (e.g., `"div"`) or React component to render as.
 * @param {React.Ref} forwardedRef - Ref forwarded to the underlying element.
 * @returns {React.ReactNode} The Scrollable component.
 */
const ScrollableComponent = ({
  children,
  renderAs,
  ...props
}, forwardedRef) => {
  const overflowRef = useContext(OverflowContext);
  return /*#__PURE__*/_jsx(ScrollContainer, {
    as: renderAs,
    ref: mergeRefs(overflowRef, forwardedRef),
    ...props,
    children: children
  });
};
const Scrollable = /*#__PURE__*/forwardRef(ScrollableComponent);
Scrollable.displayName = "Scrollable";
export default Scrollable;